import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Button } from '@material-ui/core';
import logo from '../.././assets/images/logo.png'

const useStyles = makeStyles( (theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#fff', 
    color: 'black', 
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between', 
    alignItems: 'center',
  },
  logo: {
    maxWidth: '300px',
    height: '30px',
  },
  closeButton: {
    fontSize: '14px',
    textTransform: 'capitalize',
    borderRadius: '100px',
    paddingLeft: '2rem',
    paddingRight: '2rem',
    backgroundColor: '#79232e',
    fontWeight: 700,
    color: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#a12e3d'
    },
    '&:active': {
      color: '#fff',
      backgroundColor: '#79232e'
    },
    '&:focus': {
      color: '#fff',
      backgroundColor: '#79232e'
    }
  },
}),
);

const HeaderBar = (props) => {
  const classes = useStyles();

  const host = props.host;

  const closeApplication = async () => {
    const proxy = await host;

    const close = await proxy.close();

    return close;
  };

  return (
    <AppBar position="absolute" color="default" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <img src={logo}  alt="Lenders One" className={classes.logo} />
        <Button edge="end" className={classes.closeButton} onClick={closeApplication}>
          {"Close"}
        </Button>
      </Toolbar>
    </AppBar>
  );
};

HeaderBar.propTypes = {
  host: PropTypes.object,
};

export default HeaderBar;